/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { mutatorAction } from "satcheljs";
import { appViewState } from "..";
import { TeamBasicInfoEntity } from "../../../sh-models";

/**
 * Sets the team options in the cross location select teams modal
 * @param teamOptions The team options
 */
export default mutatorAction(
    "SET_CROSS_LOCATION_SELECT_TEAMS_TEAM_OPTIONS",
    function setCrossLocationSelectTeamsTeamOptions(teamOptions: TeamBasicInfoEntity[]) {
        appViewState().crossLocationSelectTeamsModalViewState.teamOptions = teamOptions;
    }
);
